// cart page block

if (location.pathname === '/cart' && !location.search) {
	window.location.href = '/?return_link=cart';
}

// Open cart drawer when redirected with ?return_link=cart
if (new URLSearchParams(location.search).has('return_link')) {
	const cartDrawerObserver = new MutationObserver(() => {
		let cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) {
			cartDrawer.show();
			cartDrawerObserver.disconnect(); // Stop observing after cart opens
		}
	});
	cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

	// Remove return_link=cart from the URL
	const newUrl = location.href.replace(/[?&]return_link=cart/g, '');
	history.replaceState({}, document.title, newUrl);
}

// Handle browser back button to close cart
window.addEventListener('popstate', function (event) {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !location.search.includes('cartOpen=true')) {
		cartDrawer.close();
	} else if (event.state?.cart === 'show' && cartDrawer) {
		cartDrawer.show();
	}
});

// Ensure cartOpen=true is removed from URL if cart is closed
document.addEventListener('DOMContentLoaded', () => {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !cartDrawer.classList.contains('active')) {
		const newUrl = location.href.replace(/[?&]cartOpen=true/g, '');
		history.replaceState({}, document.title, newUrl);
	}
});

// Open cart and push cartOpen=true into history
function openCart() {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer) {
		cartDrawer.show();
		history.pushState({ cart: 'show' }, '', '?cartOpen=true');
	}
}

// rating js

// judgeme js

const ratingProductCard = document.querySelector(".rating-pdp-card");
const judgemeProductReviews = document.getElementById(
  "judgeme_product_reviews"
);
ratingProductCard?.addEventListener("click", function () {
  judgemeProductReviews.scrollIntoView({ behavior: "smooth" });
});

class RoundRating extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    const value = parseFloat(this.textContent.trim());
    const roundedValue = Math.round(value * 10) / 10;
    this.textContent = roundedValue.toFixed(1);
  }
}

customElements.define("round-rating", RoundRating);

// cart-change-handler.js - OPTIMIZED

document.addEventListener("cart:change", debounce(async (event) => {
  // Capture event data inside debounced function to prevent stale data
  const cartData = event.detail.cart;
  const baseEvent = event.detail.baseEvent;

  // Prevent infinite loops - don't process if this is from auto-removal or sync
  if (baseEvent === "gift-items:auto-remove") {
    return;
  }

  // First handle the case of removing add-ons when main product is gone
  const mainProducts = cartData.items.filter(
    (item) => !item.properties?._main_product && !item.parent_relationship
  );
  const addOns = cartData.items.filter(
    (item) => item.properties?._main_product
  );
  const nestedChildren = cartData.items.filter(
    (item) => item.parent_relationship?.parent_key
  );

  // If there are add-ons but no main products, remove ALL add-ons
  if (addOns.length > 0 && mainProducts.length === 0) {
    await forceRemoveAllAddons(addOns);
    return; // Exit early after handling this case
  }

  // Check if any add-ons have a main product that no longer exists
  // IMPORTANT: Skip this check immediately after variant:add events to prevent
  // removing add-ons that were just added along with their main product.
  // The addProductsToCart function adds both main product and add-ons together,
  // so we need to skip orphaned checks on variant:add to avoid race conditions.
  // Subsequent cart changes (like item:remove, line-item:change) will handle
  // truly orphaned add-ons.
  if (addOns.length > 0 && mainProducts.length > 0 && baseEvent !== "variant:add") {
    const mainProductHandles = new Set(mainProducts.map(main => main.handle));
    const orphanedAddons = addOns.filter((addon) => {
      return !mainProductHandles.has(addon.properties._main_product);
    });

    if (orphanedAddons.length > 0) {
      await forceRemoveAllAddons(orphanedAddons);
      return; // Exit early after handling this case
    }
  }

  // Handle changes to the main product quantity
  // Skip quantity sync if this event is from a sync operation itself
  if (
    baseEvent !== "addon-quantity:sync" &&
    (baseEvent === "line-item:change" ||
    baseEvent === "variant:add" ||
    baseEvent === "item:remove")
  ) {
    // Group addons by main product handle for efficient lookup
    const addonsByMainProduct = new Map();
    addOns.forEach(addon => {
      const mainHandle = addon.properties._main_product;
      if (!addonsByMainProduct.has(mainHandle)) {
        addonsByMainProduct.set(mainHandle, []);
      }
      addonsByMainProduct.get(mainHandle).push(addon);
    });
    
    // For each main product
    for (const mainProduct of mainProducts) {
      const relatedAddons = addonsByMainProduct.get(mainProduct.handle) || [];
      if (relatedAddons.length === 0) continue;

      // If main product quantity is 0, remove all its add-ons
      if (mainProduct.quantity === 0) {
        await forceRemoveAllAddons(relatedAddons);
        continue;
      }

      // For ready-to-wear, blouse customization, and remove-cups items, sync quantities
      // Gift products are NOT synced and remain independent
      const syncableAddons = relatedAddons.filter((addon) => {
        const title = (addon.product_title || '').toLowerCase();
        const variantTitle = (addon.variant_title || '').toLowerCase();
        const handle = addon.handle || '';
        
        return handle === "make-this-saree-ready-to-wear-copy" ||
               handle === "customise-blouse" ||
               handle === "remove-cups" ||
               title.includes("ready-to-wear") ||
               title.includes("pre-drape") ||
               title.includes("blouse customization") ||
               title.includes("customise blouse") ||
               title.includes("remove cups") ||
               variantTitle.includes("ready-to-wear");
      });

      if (syncableAddons.length > 0) {
        // Check if any addon needs its quantity updated
        const needsSync = syncableAddons.some(
          (addon) => addon.quantity !== mainProduct.quantity
        );

        if (needsSync) {
          await syncAddonQuantities(syncableAddons, mainProduct.quantity);
        }
      }

      const relatedNested = nestedChildren.filter(
        (child) => child.parent_relationship?.parent_key === mainProduct.key
      );

      if (relatedNested.length > 0) {
        const needsNestedSync = relatedNested.some(
          (child) => child.quantity !== mainProduct.quantity
        );

        if (needsNestedSync) {
          await syncAddonQuantities(relatedNested, mainProduct.quantity);
        }
      }
    }
  }

  if (baseEvent === "item:add" || baseEvent === "variant:add") {
    // Check confetti type from theme settings
    const confettiType = window.themeVariables?.settings?.confettiType || 'none';
    
    if (confettiType !== 'none' && typeof window.triggerConfetti === 'function') {
      window.triggerConfetti({ type: confettiType });
    }
    
    // Show toast notification on add to cart (if enabled)
    const toastEnabled = window.themeVariables?.settings?.enableToastNotification !== false;
    if (toastEnabled) {
      showAddToCartToast();
    }
  }

  // Check for gift-wrapping items - should run after all other operations
  await checkAndRemoveGiftWrappingItems(cartData);

  // Process freebies based on thresholds and cart subtotal
  await processFreebies(cartData);

  // Reinitialize carousels after cart changes
  // Use a small timeout to ensure DOM updates from cart operations are complete
  setTimeout(() => {
    if (window.CustomCarousel && typeof CustomCarousel.reinitializeAll === 'function') {
      CustomCarousel.reinitializeAll();
    }
  }, 200);
  
}, 150)); // Debounce for 150ms to reduce frequency

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Helper function to force remove all add-ons (sets quantity to 0)
async function forceRemoveAllAddons(addons) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Build updates object with all quantities set to 0
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = 0;
    });

    console.log("Removing add-ons with updates:", updates);

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) throw new Error("Failed to update cart");

    const updatedCartContent = await response.json();
    console.log("Cart updated after removing add-ons:", updatedCartContent);

    // Dispatch cart change event to update the UI
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "item:remove",
          cart: updatedCartContent,
        },
      })
    );

    // Update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error removing add-ons:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// Helper function to sync addon quantities
async function syncAddonQuantities(addons, newQuantity) {
  if (!addons || addons.length === 0) return;

  console.log(`[syncAddonQuantities] Starting sync for ${addons.length} addons to quantity ${newQuantity}`);

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Update all addons to the new quantity
    const updates = {};
    addons.forEach((addon) => {
      console.log(`[syncAddonQuantities] Setting ${addon.handle} (key: ${addon.key}) to quantity ${newQuantity}`);
      updates[addon.key] = newQuantity;
    });

    console.log("[syncAddonQuantities] Updates object:", updates);

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[syncAddonQuantities] Failed to update cart:", errorText);
      throw new Error("Failed to update cart");
    }

    const updatedCartContent = await response.json();
    console.log("[syncAddonQuantities] Cart successfully updated");

    // Dispatch a special event to prevent re-processing by the sync logic
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "addon-quantity:sync",
          cart: updatedCartContent,
        },
      })
    );

    // Force update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("[syncAddonQuantities] Error syncing addon quantities:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}
// Add this function to check and remove gift wrap and bag items when they're alone in cart
async function checkAndRemoveGiftWrappingItems(cartData) {
  // Check if cart has items
  if (!cartData || !cartData.items || cartData.items.length === 0) return;

  // Filter all gift wrap and bag items (items with _is_gift_wrap or _is_bag property)
  const giftWrapAndBagItems = cartData.items.filter(
    (item) => item.properties?._is_gift_wrap === 'Yes' || item.properties?._is_bag === 'Yes'
  );

  // Get all main products (items that are not add-ons, not gift wraps, not bags)
  const regularItems = cartData.items.filter(
    (item) => !item.properties?._main_product && 
              item.properties?._is_gift_wrap !== 'Yes' && 
              item.properties?._is_bag !== 'Yes'
  );

  console.log('Gift/Bag items count:', giftWrapAndBagItems.length);
  console.log('Main products count:', regularItems.length);
  console.log('Total items:', cartData.items.length);

  // If there are gift/bag items but NO regular items (only gifts/bags in cart), remove them
  if (giftWrapAndBagItems.length > 0 && regularItems.length === 0) {
    console.log('Only gift wrap and bag items in cart. Removing them...');
    
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      // Prepare updates to set gift wrap and bag items quantities to 0
      const updates = giftWrapAndBagItems.reduce((acc, item) => {
        acc[item.key] = 0;
        return acc;
      }, {});

      console.log('Removing gift/bag items with updates:', updates);

      // Update cart to remove gift wrap and bag items
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error("Failed to update cart");
      
      const updatedCartContent = await response.json();
      
      console.log('Successfully removed gift/bag items. Updated cart:', updatedCartContent);

      // Dispatch cart change event to update the UI
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "gift-items:auto-remove",
            cart: updatedCartContent,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
    } catch (error) {
      console.error("Error removing gift wrap and bag items:", error);
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      if (window.themeVariables?.settings.showErrorMessage) {
        alert(error.message);
      }
    }
  }
}


document.addEventListener('DOMContentLoaded', function () {
	const video = document.querySelector('.video-element');
	const muteToggle = document.getElementById('mute-toggle');
	const unmuteText = muteToggle.querySelector('.unmute-text');
	const muteText = muteToggle.querySelector('.mute-text');

	if (video && muteToggle) {
		// Toggle mute/unmute when the button is clicked
		muteToggle.addEventListener('click', function () {
			video.muted = !video.muted;

			// Toggle button text
			if (video.muted) {
				unmuteText.style.display = 'inline';
				muteText.style.display = 'none';
			} else {
				unmuteText.style.display = 'none';
				muteText.style.display = 'inline';
			}
		});

		// Toggle play/pause on video click
		video.addEventListener('click', function () {
			this.paused ? this.play() : this.pause();
		});
	}
});


document.addEventListener('DOMContentLoaded', function () {
  class ProductAddonCart extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.productHandle = this.dataset.productHandle;
      this.addEventListener('click', this.handleClick.bind(this));
      this.selectedVariantId = this.dataset.productSelectedVariant;

      // Store variant maps for addon products
      this.variantMaps = {};

      // Initialize variant maps
      this.initializeVariantMaps();

      // Set default values for selects if not already set
      this.setDefaultValues();

      this.setupEventListeners();
    }

    // Get and store variant information for all addons
    initializeVariantMaps() {
      // For pre-drape
      const preDrapeSection = this.querySelector('.pre-drape-section');
      if (preDrapeSection) {
        const variantMap = {};
        const dataAttr = preDrapeSection.getAttribute('data-variants');

        if (dataAttr) {
          try {
            // Clean and parse JSON data from the data-variants attribute
            const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
            const variantsData = JSON.parse(cleanedDataAttr);
            variantsData.forEach((variant) => {
              variantMap[variant.title] = variant.id;
            });
          } catch (e) {
            console.error('Error parsing pre-drape variants', e);
            console.error('Raw data attribute:', dataAttr);
          }
        }

        // Store the map
        this.variantMaps['pre-drape'] = variantMap;
      }

      // For blouse customization
      const blouseCustomizationSection = this.querySelector('.blouse-customization-section');
      if (blouseCustomizationSection) {
        const variantMap = {};
        const dataAttr = blouseCustomizationSection.getAttribute('data-variants');

        if (dataAttr) {
          try {
            // Clean and parse JSON data from the data-variants attribute
            const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
            const variantsData = JSON.parse(cleanedDataAttr);
            variantsData.forEach((variant) => {
              variantMap[variant.title] = variant.id;
            });
          } catch (e) {
            console.error('Error parsing blouse customization variants', e);
            console.error('Raw data attribute:', dataAttr);
          }
        }

        // Store the map
        this.variantMaps['blouse-customization'] = variantMap;
      }

      // For all addon options
      this.querySelectorAll('.addon-option').forEach((addonOption, index) => {
        const variantMap = {};
        const dataAttr = addonOption.getAttribute('data-variants');

        if (dataAttr) {
          try {
            // Clean and parse JSON data from the data-variants attribute
            const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
            const variantsData = JSON.parse(cleanedDataAttr);
            variantsData.forEach((variant) => {
              variantMap[variant.title] = variant.id;
            });
          } catch (e) {
            console.error(`Error parsing addon variants for index ${index}`, e);
            console.error('Raw data attribute:', dataAttr);
          }
        }

        // Store the map
        this.variantMaps[`addon-${index}`] = variantMap;
      });
    }

    setDefaultValues() {
      this.querySelectorAll('select').forEach((select) => {
        select.selectedIndex = 0;
      });
      this.querySelectorAll('input.pre-drape-size[type="radio"]').forEach((radio) => {
        radio.checked = false;
      });
    }

    setupEventListeners() {
      // Addon dropdown triggers (pre-drape radios, blouse select)
      this.querySelectorAll('.addon-dropdown-section').forEach((section) => {
        const trigger = section.querySelector('.addon-dropdown__trigger');
        const panel = section.querySelector('.addon-dropdown__panel');
        const checkbox = section.querySelector('.pre-drape-checkbox, .blouse-customization-checkbox');
        const blouseSelect = section.querySelector('.blouse-customization-size');
        const preDrapeRadios = section.querySelectorAll('input.pre-drape-size[type="radio"]');
        const chevron = trigger?.querySelector('.addon-dropdown__chevron');
        const icon = chevron || trigger?.querySelector('svg');

        if (!trigger || !panel) return;

        trigger.addEventListener('click', () => {
          const isNowHidden = panel.classList.toggle('hidden');
          trigger.setAttribute('aria-expanded', (!isNowHidden).toString());
          if (icon) icon.style.transform = isNowHidden ? 'rotate(180deg)' : '';
        });

        const syncFromSize = () => {
          const preDrapeChecked = section.querySelector('input.pre-drape-size:checked');
          const hasPreDrape = !!(preDrapeChecked && preDrapeChecked.value);
          const hasBlouse = !!(blouseSelect && blouseSelect.value);
          const hasSelection = hasPreDrape || hasBlouse;
          if (checkbox) {
            checkbox.checked = hasSelection;
            trigger.classList.toggle('addon-dropdown__trigger--selected', hasSelection);
            this.toggleAddToCartButton();
          }
        };

        if (blouseSelect && checkbox) {
          blouseSelect.addEventListener('change', syncFromSize);
        }
        if (preDrapeRadios.length && checkbox) {
          preDrapeRadios.forEach((radio) => radio.addEventListener('change', syncFromSize));
        }
        const clearPreDrapeBtn = section.querySelector('.pre-drape-clear-text');
        if (clearPreDrapeBtn && checkbox && preDrapeRadios.length) {
          clearPreDrapeBtn.addEventListener('click', () => {
            preDrapeRadios.forEach((radio) => {
              radio.checked = false;
            });
            syncFromSize();
          });
        }
      });

      // Toggle buttons for main options (addon-options, gifting, gift-wrap, gift-box, bags)
      this.querySelectorAll('.addon-toggle-button').forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const targetClass = button.dataset.target;
          const targetContainer = this.querySelector(`.${targetClass}`);
          const toggleIcon = button.querySelector('.toggle-icon');
          const chevron = button.querySelector('.addon-dropdown__chevron');
          const svgFallback = chevron ? null : button.querySelector('svg');

          if (targetContainer) {
            const isHiddenBefore = targetContainer.classList.contains('hidden');
            targetContainer.classList.toggle('hidden');
            const isExpanded = !targetContainer.classList.contains('hidden');
            button.classList.toggle('active', isExpanded);
            button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

            if (toggleIcon) {
              toggleIcon.textContent = isHiddenBefore ? '−' : '+';
            } else if (chevron) {
              chevron.style.transform = isHiddenBefore ? '' : 'rotate(180deg)';
            } else if (svgFallback) {
              svgFallback.style.transform = isHiddenBefore ? '' : 'rotate(180deg)';
            }

            if (!isHiddenBefore) {
              targetContainer.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
              });
            }

            this.toggleAddToCartButton();
          }
        });
      });

      // Individual nested option checkboxes (gift wrap, gift box, bags, addons)
      this.querySelectorAll('.gift-wrap-option-checkbox, .gift-box-option-checkbox, .bags-option-checkbox, .addon-checkbox').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          if (checkbox.classList.contains('addon-checkbox')) {
            this.toggleAddonFields(checkbox);
          }
          this.updateToggleButtonState(checkbox);
          this.toggleAddToCartButton();
        });
      });

      // Remove cups fields toggle
      const removeCupsCheckbox = this.querySelector('.remove-cups-checkbox');
      const removeCupsMessageContainer = this.querySelector('.remove-cups-message-container');

      if (removeCupsCheckbox && removeCupsMessageContainer) {
        removeCupsCheckbox.addEventListener('change', () => {
          removeCupsMessageContainer.classList.toggle('hidden', !removeCupsCheckbox.checked);
          this.toggleAddToCartButton();
        });
      }
    }

    toggleAddonFields(checkbox) {
      const addonOption = checkbox.closest('.addon-option');
      const addonFields = addonOption.querySelector('.addon-fields');

      if (addonFields) {
        addonFields.classList.toggle('hidden', !checkbox.checked);
      }
    }

    updateToggleButtonState(checkbox) {
      // Find the parent container (gift-wrap-options, gift-box-options, bags-options, gifting-options, or addon-options)
      const optionsContainer = checkbox.closest('.gift-wrap-options, .gift-box-options, .bags-options, .gifting-options, .addon-options');
      
      if (!optionsContainer) return;

      // Find the corresponding toggle button
      const parentSection = optionsContainer.closest('.gift-wrap-container, .gift-box-container, .bags-container, .gifting-container, .addon-selection-container');
      
      if (!parentSection) return;

      const toggleButton = parentSection.querySelector('.addon-toggle-button');
      
      if (!toggleButton) return;

      // Check if any checkbox in this container is checked
      const anyChecked = optionsContainer.querySelector('input[type="checkbox"]:checked');
      
      // Update active class based on selection, but don't auto-hide the container
      if (!anyChecked) {
        toggleButton.classList.remove('active');
      } else {
        // Keep it active if any checkbox is checked
        toggleButton.classList.add('active');
      }
    }

    toggleAddToCartButton() {
      const isAnyCheckboxChecked =
        this.querySelector('.pre-drape-checkbox:checked') ||
        this.querySelector('.blouse-customization-checkbox:checked') ||
        this.querySelector('.addon-checkbox:checked') ||
        this.querySelector('.gift-wrap-option-checkbox:checked') ||
        this.querySelector('.gift-box-option-checkbox:checked') ||
        this.querySelector('.bags-option-checkbox:checked') ||
        this.querySelector('.remove-cups-checkbox:checked');

      const button = this.querySelector('.addon-submit-button');
      const mainContainer = this;

      const productInfoATCs = document.querySelectorAll(
        '.product .product-info__block-item[data-block-type="buy-buttons"]'
      );
      const stickyBar = document.querySelector('product-sticky-bar');

      const allATCs = [...productInfoATCs, ...(stickyBar ? [stickyBar] : [])];

      if (button) {
        button.classList.toggle('hidden', !isAnyCheckboxChecked);
        mainContainer?.classList?.toggle('on-checked-container', !!isAnyCheckboxChecked);
        allATCs.forEach((atc) => atc?.classList?.toggle('hidden', isAnyCheckboxChecked));
      }
    }

    validateFields() {
      let isValid = true;
      const errors = [];

      const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
      if (preDrapeCheckbox?.checked) {
        const preDrapeChecked = this.querySelector('input.pre-drape-size:checked');
        if (!preDrapeChecked?.value) {
          errors.push('Please select a size for pre-drape service');
          isValid = false;
        }
      }

      const blouseCustomizationCheckbox = this.querySelector('.blouse-customization-checkbox');
      if (blouseCustomizationCheckbox?.checked) {
        const sizeSelect = this.querySelector('.blouse-customization-size');
        if (!sizeSelect.value || sizeSelect.value === '') {
          errors.push('Please select a size for blouse customization');
          isValid = false;
        }
      }

      if (!isValid) {
        alert(errors.join('\n'));
      }

      return isValid;
    }


    resetForm() {
      this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        if (!checkbox.disabled) {
          checkbox.checked = false;
        }
      });

      this.querySelectorAll('.addon-toggle-button').forEach((button) => {
        button.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
        const toggleIcon = button.querySelector('.toggle-icon');
        const chevron = button.querySelector('.addon-dropdown__chevron');
        const svgFallback = chevron ? null : button.querySelector('svg');
        if (toggleIcon) {
          toggleIcon.textContent = '+';
        } else if (chevron) {
          chevron.style.transform = 'rotate(180deg)';
        } else if (svgFallback) {
          svgFallback.style.transform = 'rotate(180deg)';
        }
      });

      this.querySelectorAll('input.pre-drape-size[type="radio"]').forEach((radio) => {
        radio.checked = false;
      });

      this.querySelectorAll('select').forEach((select) => {
        if (select.classList.contains('blouse-customization-size')) {
          select.value = '';
        } else if (select.options.length > 0) {
          const selectedOption = select.querySelector('option[selected]');
          if (selectedOption) {
            select.value = selectedOption.value;
          } else {
            select.selectedIndex = 0;
          }
        }
      });

      this.querySelectorAll('input[type="number"], input[type="text"]').forEach((input) => {
        input.value = '';
      });

      this.querySelectorAll('.addon-dropdown-section').forEach((section) => {
        const panel = section.querySelector('.addon-dropdown__panel');
        const trigger = section.querySelector('.addon-dropdown__trigger');
        const chevron = trigger?.querySelector('.addon-dropdown__chevron');
        const icon = chevron || trigger?.querySelector('svg');
        if (panel) panel.classList.add('hidden');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.classList.remove('addon-dropdown__trigger--selected');
        }
        if (icon) icon.style.transform = 'rotate(180deg)';
      });

      this.querySelectorAll('.addon-fields').forEach((field) => {
        field.classList.add('hidden');
      });

      this.querySelectorAll('.remove-cups-message-container').forEach((el) => {
        el.classList.add('hidden');
      });

      this.querySelectorAll('.addon-options, .gift-wrap-options, .gift-box-options, .bags-options, .gifting-options').forEach((container) => {
        container.classList.add('hidden');
      });

      this.toggleAddToCartButton();
    }

    async handleClick(event) {
      // Only handle the main add-to-cart submit button
      if (!event.target.matches('.addon-submit-button')) return;

      event.preventDefault();

      if (!this.validateFields()) return;

      // Add loading spinner to body
      document.body.classList.add('loading-spinner');
      if (typeof window.showCustomLoadingOverlay === 'function') {
        window.showCustomLoadingOverlay();
      }

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        await this.addProductsToCart();
      } catch (error) {
        console.error('Error adding products to cart:', error);
        alert(error.message || 'An error occurred while adding products to cart');
      } finally {
        document.body.classList.remove('loading-spinner');
        if (typeof window.hideCustomLoadingOverlay === 'function') {
          window.hideCustomLoadingOverlay();
        }
        this.resetForm();
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    async addProductsToCart() {
      const currentPath = window.location.pathname || window.location.href.split('?')[0].split('#')[0];
      const productPathMatch = currentPath.match(/\/products\/([^/?#]+)/);
      let mainProductTitle = productPathMatch ? productPathMatch[1] : null;

      if (!mainProductTitle) {
        mainProductTitle = this.dataset.productHandle || this.productHandle;
      }

      if (!mainProductTitle) {
        const allForms = document.querySelectorAll('form[action*="/cart/add"]');
        const mainProductForm = Array.from(allForms).find((form) => {
          return !form.closest('quick-buy-modal') && !form.closest('[role="dialog"]') && !form.closest('.modal');
        });

        if (mainProductForm) {
          const formAction = mainProductForm.getAttribute('action') || '';
          const formMatch = formAction.match(/\/products\/([^/?#]+)/);
          if (formMatch) {
            mainProductTitle = formMatch[1];
          }
        }
      }

      if (!mainProductTitle) {
        throw new Error('Unable to determine main product. Please refresh the page and try again.');
      }

      const allQuantityInputs = document.querySelectorAll('input[name="quantity"]');
      const mainQuantityInput = Array.from(allQuantityInputs).find((input) => {
        return !input.closest('quick-buy-modal') && !input.closest('[role="dialog"]') && !input.closest('.modal');
      });
      const mainProductQuantity = mainQuantityInput?.value || 1;

      const allForms = document.querySelectorAll('form[action*="/cart/add"]');
      const mainProductForm = Array.from(allForms).find((form) => {
        return !form.closest('quick-buy-modal') && !form.closest('[role="dialog"]') && !form.closest('.modal');
      });

      let mainVariantId = null;

      if (mainProductForm) {
        const variantInput = mainProductForm.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          mainVariantId = parseInt(variantInput.value, 10);
        }
      }

      if (!mainVariantId || isNaN(mainVariantId)) {
        mainVariantId =
          typeof this.selectedVariantId === 'string' ? parseInt(this.selectedVariantId, 10) : this.selectedVariantId;
      }

      if (!mainVariantId || isNaN(mainVariantId)) {
        const datasetVariantId = this.dataset.productSelectedVariant;
        if (datasetVariantId) {
          mainVariantId = parseInt(datasetVariantId, 10);
        }
      }

      if (!mainVariantId || isNaN(mainVariantId)) {
        throw new Error('Unable to determine product variant. Please refresh the page and try again.');
      }

      const items = [];

      items.push({
        id: mainVariantId,
        quantity: parseInt(mainProductQuantity, 10),
        properties: {},
      });

      const preDrapeSection = this.querySelector('.pre-drape-section');
      if (preDrapeSection && this.querySelector('.pre-drape-checkbox').checked) {
        const preDrapeChecked = this.querySelector('input.pre-drape-size:checked');
        const preDrapeMessageInput = this.querySelector('.pre-drape-message-input');
        const preDrapeMessage = preDrapeMessageInput?.value?.trim?.() ?? '';

        const variantId =
          preDrapeChecked?.value != null && preDrapeChecked.value !== ''
            ? parseInt(preDrapeChecked.value, 10)
            : null;

        if (!variantId || isNaN(variantId)) {
          throw new Error('Please select a size for pre-drape service');
        }

        items.push({
          id: variantId,
          quantity: parseInt(mainProductQuantity, 10),
          properties: {
            _main_product: mainProductTitle,
            ...(preDrapeMessage ? { instructions: preDrapeMessage } : {}),
          },
        });
        items[0].properties._has_pre_drape = 'Yes';
      }

      const blouseCustomizationSection = this.querySelector('.blouse-customization-section');
      if (blouseCustomizationSection && this.querySelector('.blouse-customization-checkbox').checked) {
        const sizeSelect = this.querySelector('.blouse-customization-size');
        const blouseCustomizationMessageInput = this.querySelector('.blouse-customization-message-input');
        const blouseCustomizationMessage = blouseCustomizationMessageInput?.value?.trim?.() ?? '';

        const variantId = sizeSelect.value ? parseInt(sizeSelect.value, 10) : null;

        if (!variantId || isNaN(variantId)) {
          throw new Error('Please select a size for blouse customization');
        }

        items.push({
          id: variantId,
          quantity: parseInt(mainProductQuantity, 10),
          properties: {
            _main_product: mainProductTitle,
            ...(blouseCustomizationMessage ? { instructions: blouseCustomizationMessage } : {}),
          },
        });
        items[0].properties._has_blouse_customization = 'Yes';
      }

      this.querySelectorAll('.addon-option').forEach((addonOption) => {
        const addonCheckbox = addonOption.querySelector('.addon-checkbox');
        if (addonCheckbox.checked) {
          const sizeSelect = addonOption.querySelector('.addon-size');
          let selectedVariantId;

          if (sizeSelect && sizeSelect.value) {
            selectedVariantId = parseInt(sizeSelect.value, 10);
            if (isNaN(selectedVariantId)) {
              throw new Error('Invalid variant ID for addon');
            }
          } else {
            try {
              const variantsData = JSON.parse(addonOption.dataset.variants);
              if (variantsData && variantsData.length > 0) {
                selectedVariantId = parseInt(variantsData[0].id, 10);
              } else {
                throw new Error('No variants found');
              }
            } catch (e) {
              console.error('Error parsing addon variants:', e);
              alert('Error selecting addon variant. Please try again.');
              return;
            }
          }

          items.push({
            id: selectedVariantId,
            quantity: 1,
            properties: {
              _main_product: mainProductTitle,
              ...(sizeSelect && sizeSelect.value ? { size: sizeSelect.value } : {}),
            },
          });

          items[0].properties._has_addon = 'Yes';
        }
      });

      this.querySelectorAll('.gift-wrap-option').forEach((giftWrapOption) => {
        const giftWrapCheckbox = giftWrapOption.querySelector('.gift-wrap-option-checkbox');
        if (giftWrapCheckbox.checked) {
          const giftWrapVariantId = giftWrapOption.dataset.variantId;
          items.push({
            id: giftWrapVariantId,
            quantity: 1,
            properties: {
              _is_gift_wrap: 'Yes',
            },
          });
        }
      });

      this.querySelectorAll('.gift-box-option').forEach((giftBoxOption) => {
        const giftBoxCheckbox = giftBoxOption.querySelector('.gift-box-option-checkbox');
        if (giftBoxCheckbox.checked) {
          const giftBoxVariantId = giftBoxOption.dataset.variantId;
          items.push({
            id: giftBoxVariantId,
            quantity: 1,
          });
        }
      });

      this.querySelectorAll('.bags-option').forEach((bagsOption) => {
        const bagsCheckbox = bagsOption.querySelector('.bags-option-checkbox');
        if (bagsCheckbox.checked) {
          const bagsVariantId = bagsOption.dataset.variantId;
          items.push({
            id: bagsVariantId,
            quantity: 1,
            properties: {
              _is_bag: 'Yes',
            },
          });
        }
      });

      const removeCupsSection = this.querySelector('.remove-cups-section');
      if (removeCupsSection && this.querySelector('.remove-cups-checkbox').checked) {
        const removeCupsMessageInput = this.querySelector('.remove-cups-message-input');
        const removeCupsMessage = removeCupsMessageInput?.value?.trim?.() ?? '';

        const removeCupsVariantId = removeCupsSection.dataset.variantId
          ? parseInt(removeCupsSection.dataset.variantId, 10)
          : null;

        if (!removeCupsVariantId || isNaN(removeCupsVariantId)) {
          throw new Error('Unable to determine remove cups variant');
        }

        items.push({
          id: removeCupsVariantId,
          quantity: parseInt(mainProductQuantity, 10),
          properties: {
            _main_product: mainProductTitle,
            ...(removeCupsMessage ? { instructions: removeCupsMessage } : {}),
          },
        });
        items[0].properties._has_remove_cups = 'Yes';
      }

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const responseJson = await response.json();

      if (response.ok) {
        if (window.themeVariables?.settings?.cartType === 'page') {
          window.location.href = `${window.Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        this.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      } else {
        let errorMessage = responseJson.description || responseJson.message || 'Unable to add items to cart';

        if (responseJson.errors) {
          if (typeof responseJson.errors === 'string') {
            errorMessage = responseJson.errors;
          } else if (typeof responseJson.errors === 'object') {
            errorMessage = Object.values(responseJson.errors).flat().join(', ');
          }
        }

        if (
          errorMessage.toLowerCase().includes('sold out') ||
          errorMessage.toLowerCase().includes('out of stock') ||
          errorMessage.toLowerCase().includes('not available')
        ) {
          errorMessage =
            'One or more items are currently out of stock. Please review your selections and try again.\n\nDetails: ' +
            errorMessage;
        }

        throw new Error(errorMessage);
      }
    }
  }

  customElements.define('product-addon-cart', ProductAddonCart);
});

// =====================
// Blouse customization PDP (nested cart lines)
// =====================

document.addEventListener('DOMContentLoaded', function () {
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') {
      cents = parseInt(cents, 10) || 0;
    }

    const value = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();
    const amountWithComma = value.replace('.', ',');
    const amountWithSpace = value.replace('.', ' ');
    const amountWithApostrophe = value.replace('.', "'");

    if (!format) {
      return value;
    }

    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, amountWithSpace)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amountWithApostrophe)
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  class BlouseCustomizationForm extends HTMLElement {
    constructor() {
      super();
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      this.baseVariantId = parseInt(this.dataset.baseVariantId, 10);
      this.basePrice = parseInt(this.dataset.basePrice, 10) || 0;
      this.productHandle = this.dataset.productHandle;

      this.addEventListener('click', this.handleClick.bind(this));
      this.setupEventListeners();
      this.syncBaseVariantFromForm();
      this.querySelectorAll('.blouse-customization-pdp__option-checkbox:checked').forEach((checkbox) => {
        this.toggleOptionPanel(checkbox);
      });
      this.updatePricing();
    }

    isOptionActive(option) {
      const hasVariants = option.dataset.hasVariants === 'true';

      if (hasVariants) {
        return !!option.querySelector('.blouse-customization-pdp__variant-radio:checked');
      }

      return !!option.querySelector('.blouse-customization-pdp__option-checkbox')?.checked;
    }

    getOptionLabel(option) {
      return option.querySelector('.blouse-customization-pdp__option-label')?.textContent?.trim() || 'Option';
    }

    setupEventListeners() {
      this.querySelectorAll('.blouse-customization-pdp__option-checkbox').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          this.toggleOptionPanel(checkbox);
          this.updatePricing();
        });
      });

      this.querySelectorAll('.blouse-customization-pdp__variant-radio').forEach((radio) => {
        radio.addEventListener('change', () => this.updatePricing());
      });

      document.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (variant?.id) {
          this.baseVariantId = parseInt(variant.id, 10);
          this.basePrice = parseInt(variant.price, 10) || 0;
          const hiddenInput = this.querySelector('.blouse-customization-pdp__base-variant-input');
          if (hiddenInput) {
            hiddenInput.value = this.baseVariantId;
          }
          this.updatePricing();
        } else {
          this.syncBaseVariantFromForm();
          this.updatePricing();
        }
      });
    }

    syncBaseVariantFromForm() {
      const allForms = document.querySelectorAll('form[action*="/cart/add"]');
      const form = Array.from(allForms).find((entry) => {
        return !entry.closest('quick-buy-modal') && !entry.closest('[role="dialog"]') && !entry.closest('.modal');
      });

      const variantInput = form?.querySelector('input[name="id"]');
      if (variantInput?.value) {
        const nextVariantId = parseInt(variantInput.value, 10);
        if (!isNaN(nextVariantId)) {
          this.baseVariantId = nextVariantId;
        }
      }

      const hiddenInput = this.querySelector('.blouse-customization-pdp__base-variant-input');
      if (hiddenInput) {
        hiddenInput.value = this.baseVariantId;
      }
    }

    toggleOptionPanel(checkbox) {
      const option = checkbox.closest('.blouse-customization-pdp__option');
      const variantPanel = option?.querySelector('[data-variant-panel]');
      if (!variantPanel) return;

      variantPanel.classList.toggle('hidden', !checkbox.checked);

      if (checkbox.checked) {
        const firstRadio = variantPanel.querySelector('.blouse-customization-pdp__variant-radio:not(:checked)');
        const checkedRadio = variantPanel.querySelector('.blouse-customization-pdp__variant-radio:checked');
        if (!checkedRadio && firstRadio) {
          firstRadio.checked = true;
        }
      }
    }

    getSelectedOptions() {
      const selected = [];

      this.querySelectorAll('.blouse-customization-pdp__option').forEach((option) => {
        if (!this.isOptionActive(option)) return;

        const hasVariants = option.dataset.hasVariants === 'true';
        let variantId = parseInt(option.dataset.defaultVariantId, 10);
        let price = 0;

        if (hasVariants) {
          const checkedRadio = option.querySelector('.blouse-customization-pdp__variant-radio:checked');
          if (!checkedRadio?.value) return;
          variantId = parseInt(checkedRadio.value, 10);
          price = parseInt(checkedRadio.dataset.price, 10) || 0;
        } else {
          try {
            const variants = JSON.parse(option.dataset.variants || '[]');
            const match = variants.find((entry) => parseInt(entry.id, 10) === variantId);
            price = match?.price || 0;
          } catch (e) {
            price = 0;
          }
        }

        if (!variantId || isNaN(variantId)) return;

        selected.push({ variantId, price, option });
      });

      return selected;
    }

    updatePricing() {
      let total = this.basePrice;

      this.querySelectorAll('.blouse-customization-pdp__option').forEach((option) => {
        const priceEl = option.querySelector('[data-option-price]');
        const hasVariants = option.dataset.hasVariants === 'true';
        const isActive = this.isOptionActive(option);

        option.classList.toggle('is-selected', isActive);

        if (!isActive) {
          if (hasVariants && priceEl) {
            priceEl.textContent = '';
            priceEl.classList.add('hidden');
          }
          return;
        }

        let optionPrice = 0;
        if (hasVariants) {
          const checkedRadio = option.querySelector('.blouse-customization-pdp__variant-radio:checked');
          optionPrice = parseInt(checkedRadio?.dataset.price, 10) || 0;
        } else {
          try {
            const variants = JSON.parse(option.dataset.variants || '[]');
            const defaultVariantId = parseInt(option.dataset.defaultVariantId, 10);
            const match = variants.find((entry) => parseInt(entry.id, 10) === defaultVariantId) || variants[0];
            optionPrice = match?.price || 0;
          } catch (e) {
            optionPrice = 0;
          }
        }

        total += optionPrice;

        if (priceEl) {
          if (optionPrice > 0) {
            priceEl.textContent = `+${formatMoney(optionPrice, this.moneyFormat)}`;
            priceEl.classList.remove('hidden');
          } else {
            priceEl.textContent = '';
            priceEl.classList.add('hidden');
          }
        }
      });

      const totalEl = this.querySelector('[data-total-price]');
      if (totalEl) {
        totalEl.textContent = formatMoney(total, this.moneyFormat);
      }

      const atcButton = this.querySelector('[data-action="add-to-cart"]');
      if (atcButton) {
        atcButton.classList.toggle('hidden', total === 0);
        atcButton.disabled = total === 0;
      }
    }

    validateSelections() {
      const errors = [];

      this.querySelectorAll('.blouse-customization-pdp__option').forEach((option) => {
        const isRequired = option.dataset.required === 'true';
        const hasVariants = option.dataset.hasVariants === 'true';
        const label = this.getOptionLabel(option);

        if (hasVariants) {
          const checkedRadio = option.querySelector('.blouse-customization-pdp__variant-radio:checked');
          if (isRequired && !checkedRadio?.value) {
            errors.push(`Please choose an option for ${label}`);
          }
          return;
        }

        const checkbox = option.querySelector('.blouse-customization-pdp__option-checkbox');
        if (isRequired && !checkbox?.checked) {
          errors.push(`Please select ${label}`);
        }
      });

      if (errors.length > 0) {
        alert(errors.join('\n'));
        return false;
      }

      return true;
    }

    getMainProductQuantity() {
      const allQuantityInputs = document.querySelectorAll('input[name="quantity"]');
      const mainQuantityInput = Array.from(allQuantityInputs).find((input) => {
        return !input.closest('quick-buy-modal') && !input.closest('[role="dialog"]') && !input.closest('.modal');
      });
      return parseInt(mainQuantityInput?.value, 10) || 1;
    }

    async handleClick(event) {
      const button = event.target.closest('[data-action]');
      if (!button || !this.contains(button)) return;

      event.preventDefault();

      if (!this.validateSelections()) return;

      const action = button.dataset.action;
      const redirectToCheckout = action === 'buy-now';

      document.body.classList.add('loading-spinner');
      if (typeof window.showCustomLoadingOverlay === 'function') {
        window.showCustomLoadingOverlay();
      }
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        await this.addToCart(redirectToCheckout);
      } catch (error) {
        console.error('Blouse customization cart error:', error);
        alert(error.message || 'Unable to add items to cart');
      } finally {
        document.body.classList.remove('loading-spinner');
        if (typeof window.hideCustomLoadingOverlay === 'function') {
          window.hideCustomLoadingOverlay();
        }
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    async addToCart(redirectToCheckout = false) {
      this.syncBaseVariantFromForm();

      if (!this.baseVariantId || isNaN(this.baseVariantId)) {
        throw new Error('Unable to determine product variant. Please refresh and try again.');
      }

      const quantity = this.getMainProductQuantity();
      const selectedOptions = this.getSelectedOptions();

      const items = [
        {
          id: this.baseVariantId,
          quantity,
        },
      ];

      selectedOptions.forEach(({ variantId }) => {
        items.push({
          id: variantId,
          quantity,
          parent_id: this.baseVariantId,
        });
      });

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items,
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const responseJson = await response.json();

      if (!response.ok) {
        let errorMessage = responseJson.description || responseJson.message || 'Unable to add items to cart';
        if (responseJson.errors) {
          if (typeof responseJson.errors === 'string') {
            errorMessage = responseJson.errors;
          } else if (typeof responseJson.errors === 'object') {
            errorMessage = Object.values(responseJson.errors).flat().join(', ');
          }
        }
        throw new Error(errorMessage);
      }

      if (redirectToCheckout) {
        window.location.href = `${window.Shopify.routes.root}checkout`;
        return;
      }

      if (window.themeVariables?.settings?.cartType === 'page') {
        window.location.href = `${window.Shopify.routes.root}cart`;
        return;
      }

      const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      cartContent.sections = responseJson.sections;

      this.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson],
            cart: cartContent,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent,
          },
        })
      );
    }
  }

  if (!window.customElements.get('blouse-customization-form')) {
    window.customElements.define('blouse-customization-form', BlouseCustomizationForm);
  }
});

// =====================
// Freebies functionality
// =====================

let __isProcessingFreebies = false;
const __freebieVariantCache = {};

function getFreebieConfig() {
  const settings = window.themeVariables?.settings;
  const config = settings?.freebiesConfig;
  if (!config || typeof config.enabled === 'undefined') return null;

  // Normalize items (filter invalid entries)
  const items = Array.isArray(config.items)
    ? config.items
        .filter((it) => it && typeof it.threshold === 'number' && it.handle)
        .map((it) => ({ threshold: it.threshold, handle: String(it.handle).trim() }))
    : [];

  return { enabled: !!config.enabled, items };
}

function isFreebieLineItem(item) {
  return item?.properties?._is_freebie === 'true';
}

async function getDefaultVariantId(productHandle) {
  if (!productHandle) return null;
  if (__freebieVariantCache[productHandle]) return __freebieVariantCache[productHandle];

  try {
    const res = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
    if (!res.ok) throw new Error('Failed to load product');
    const product = await res.json();
    const variant = product?.variants?.find((v) => v.available) || product?.variants?.[0];
    if (!variant) return null;
    __freebieVariantCache[productHandle] = variant.id;
    return variant.id;
  } catch (e) {
    console.warn('Freebie variant fetch failed for', productHandle, e);
    return null;
  }
}

async function addFreebieProducts(handles) {
  if (!handles || handles.length === 0) return null;

  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  );

  const items = [];
  for (const handle of handles) {
    const variantId = await getDefaultVariantId(handle);
    if (variantId) {
      items.push({
        id: variantId,
        quantity: 1,
        properties: { _is_freebie: 'true' },
      });
    }
  }

  if (items.length === 0) return null;

  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      items,
      sections: sectionsToBundle.join(','),
      sections_url: window.location.pathname,
    }),
  });

  const responseJson = await response.json();
  if (!response.ok) throw new Error(responseJson?.description || 'Failed to add freebies');

  const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
  cartContent.sections = responseJson.sections;

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: cartContent },
    })
  );

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart && typeof cart.renderContents === 'function') {
    cart.renderContents(cartContent);
  }

  return cartContent;
}

async function removeFreebieLineItems(itemsToRemove) {
  if (!itemsToRemove || itemsToRemove.length === 0) return null;

  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  );

  const updates = {};
  itemsToRemove.forEach((item) => {
    updates[item.key] = 0;
  });

  const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      updates,
      sections: sectionsToBundle.join(','),
      sections_url: window.location.pathname,
    }),
  });

  const updatedCartContent = await response.json();
  if (!response.ok) throw new Error('Failed to remove freebies');

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'item:remove', cart: updatedCartContent },
    })
  );

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart && typeof cart.renderContents === 'function') {
    cart.renderContents(updatedCartContent);
  }

  return updatedCartContent;
}

async function processFreebies(cartData) {
  const cfg = getFreebieConfig();
  if (!cfg || !cfg.enabled) return;
  if (__isProcessingFreebies) return;

  try {
    __isProcessingFreebies = true;

    const subtotal = Math.round((cartData?.items_subtotal_price || 0) / 100);

    // Range-based: only the highest qualifying freebie (remove lesser threshold freebie when next tier is reached)
    const qualifying = cfg.items.filter((it) => subtotal >= it.threshold);
    const topItem = qualifying.length > 0
      ? qualifying.reduce((best, it) => (it.threshold > best.threshold ? it : best))
      : null;
    const eligibleHandles = topItem ? [topItem.handle] : [];

    const freebiesInCart = (cartData.items || []).filter((it) => isFreebieLineItem(it));
    const freebiesInCartHandles = freebiesInCart.map((it) => it.handle);

    const handlesToAdd = eligibleHandles.filter((h) => !freebiesInCartHandles.includes(h));
    const freebiesToRemove = freebiesInCart.filter((it) => !eligibleHandles.includes(it.handle));

    if (handlesToAdd.length === 0 && freebiesToRemove.length === 0) return;

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    // Remove first, then add, to avoid duplicates
    if (freebiesToRemove.length > 0) {
      await removeFreebieLineItems(freebiesToRemove);
    }

    if (handlesToAdd.length > 0) {
      await addFreebieProducts(handlesToAdd);
    }
  } catch (e) {
    console.warn('Freebies processing error:', e);
  } finally {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    __isProcessingFreebies = false;
  }
}

 // 🚀 100% OPTIMIZED LAZY LOADING SYSTEM FOR MAXIMUM CORE WEB VITALS PERFORMANCE
  
  // PHASE 1: IMMEDIATE CRITICAL STYLES (NO DELAYS) ⚡
  (function injectCriticalStyles() {
    const criticalStyle = document.createElement('style');
    criticalStyle.textContent = `
      /* Critical loading states - prevent FOUC */
      img[loading="lazy"] { 
        transition: opacity 0.2s ease, filter 0.2s ease;
        background: linear-gradient(90deg, #f8f8f8 25%, #eee 50%, #f8f8f8 75%);
        background-size: 200% 100%;
      }
      
      img.priority-image { 
        opacity: 1; 
        filter: none; 
        background: none;
        animation: none;
      }
      
      img.lazy-loading { 
        opacity: 0.7; 
        filter: blur(1px);
        animation: skeleton-pulse 1.5s ease-in-out infinite;
      }
      
      img.lazy-loaded { 
        opacity: 1; 
        filter: none; 
        background: none;
        animation: none;
      }
      
      img.lazy-error { 
        opacity: 0.4; 
        background: #f5f5f5;
        animation: none;
      }
      
      img.lcp-candidate { 
        content-visibility: auto; 
      }
      
      /* High-performance skeleton animation */
      @keyframes skeleton-pulse {
        0%, 100% { background-position: 200% 0; opacity: 0.7; }
        50% { background-position: -200% 0; opacity: 0.9; }
      }
      
      /* CLS prevention - maintain aspect ratios */
      .hero-banner img,
      .slideshow img {
        object-fit: cover;
        aspect-ratio: attr(width) / attr(height);
      }
      .product-card__image {
        aspect-ratio: 3/4;
      }
      
      /* Performance hints for critical images */
      .priority-image,
      .lcp-candidate {
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
      }
    `;
    
    // Inject immediately - no waits
    if (document.head) {
      document.head.appendChild(criticalStyle);
    } else {
      // Fallback for very early execution
      document.addEventListener('DOMContentLoaded', () => document.head.appendChild(criticalStyle));
    }
  })();

  // PHASE 2: ULTRA-EARLY CRITICAL OPERATIONS ⚡
  (function initializeUltraEarlyOptimizations() {
    let hasRun = false;
    const preloadedUrls = new Set();
    
    function optimizeImage(img, isHero = false) {
      // Skip if image is in a hidden carousel slide
      const parentSlide = img.closest('.splide__slide:not(.is-active), .splide__slide[aria-hidden="true"]');
      if (parentSlide) return false;
      
      // Skip if image is lazy-loaded but not yet activated
      if (img.dataset.src && !img.src && img.loading === 'lazy') return false;
      
      const imageUrl = img.src || img.currentSrc;
      if (!imageUrl || imageUrl === 'data:,' || !imageUrl.startsWith('http')) return false;
      if (preloadedUrls.has(imageUrl)) return false;
      
      // Check if preload link already exists
      if (document.querySelector(`link[rel="preload"][as="image"][href="${imageUrl}"]`)) {
        preloadedUrls.add(imageUrl);
        return false;
      }
      
      img.loading = 'eager';
      img.fetchPriority = 'high';
      img.classList.add('priority-image');
      
      // Create preload link
      const preloadLink = document.createElement('link');
      preloadLink.rel = 'preload';
      preloadLink.as = 'image';
      preloadLink.href = imageUrl;
      preloadLink.fetchPriority = 'high';
      if (img.srcset) {
        preloadLink.imagesrcset = img.srcset;
        preloadLink.imagesizes = img.sizes || (isHero ? '100vw' : '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw');
      }
      document.head[isHero ? 'prepend' : 'appendChild'](preloadLink);
      preloadedUrls.add(imageUrl);
      return true;
    }
    
    function runCriticalOptimizations() {
      if (hasRun || !document.body) return;
      hasRun = true;
      
      const viewportHeight = window.innerHeight;
      
      // CRITICAL: Above-fold image prioritization (limit to 8 for performance)
      const urgentImages = document.querySelectorAll('img[loading="lazy"]:not(.product-card__image--secondary)');
      let processed = 0;
      for (const img of urgentImages) {
        if (processed >= 8) break;
        const rect = img.getBoundingClientRect();
        if (rect.top < viewportHeight * 1.1 && rect.bottom > -100) {
          if (optimizeImage(img)) processed++;
        }
      }
      
      // CRITICAL: Hero/banner image optimization
      const heroSelectors = [
        '.slideshow img:first-child',
        '.hero-banner img:first-child', 
        '.featured-image img:first-child',
        '.banner img:first-child'
      ];
      
      for (const selector of heroSelectors) {
        const heroImg = document.querySelector(selector);
        if (heroImg && heroImg.getBoundingClientRect().top < viewportHeight) {
          optimizeImage(heroImg, true);
          break; // Only optimize first hero found
        }
      }
    }
    
    // Run ASAP when body exists
    if (document.body) {
      runCriticalOptimizations();
    } else if (document.readyState !== 'loading') {
      runCriticalOptimizations();
    } else {
      const handler = () => {
        if (document.readyState !== 'loading') {
          runCriticalOptimizations();
          document.removeEventListener('readystatechange', handler);
        }
      };
      document.addEventListener('DOMContentLoaded', runCriticalOptimizations);
      document.addEventListener('readystatechange', handler);
    }
  })();

  // PHASE 3: ADVANCED LCP OPTIMIZATION (EARLY) 🎯
  function optimizeLCPCandidate() {
    if (document.readyState === 'loading') return;
    
    // Smart LCP detection with performance scoring (limit to 10 for performance)
    const images = Array.from(document.querySelectorAll('img:not(.product-card__image--secondary)')).slice(0, 10);
    const candidates = images
      .map(img => {
        const rect = img.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (!isVisible) return null;
        
        const area = rect.width * rect.height;
        const distanceFromFold = Math.max(0, rect.top);
        const score = area / (1 + distanceFromFold * 0.01);
        
        return score > 1000 ? { img, score } : null;
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score);
    
    if (candidates.length > 0) {
      const lcpCandidate = candidates[0].img;
      
      // Skip if in hidden carousel slide
      if (lcpCandidate.closest('.splide__slide:not(.is-active), .splide__slide[aria-hidden="true"]')) return;
      
      lcpCandidate.loading = 'eager';
      lcpCandidate.fetchPriority = 'high';
      lcpCandidate.classList.add('lcp-candidate');
      
      const imageUrl = lcpCandidate.src || lcpCandidate.currentSrc;
      if (imageUrl && imageUrl !== 'data:,' && imageUrl.startsWith('http')) {
        if (!document.querySelector(`link[rel="preload"][as="image"][href="${imageUrl}"]`)) {
          const lcpPreload = document.createElement('link');
          lcpPreload.rel = 'preload';
          lcpPreload.as = 'image';
          lcpPreload.href = imageUrl;
          lcpPreload.fetchPriority = 'high';
          if (lcpCandidate.srcset) {
            lcpPreload.imagesrcset = lcpCandidate.srcset;
            lcpPreload.imagesizes = lcpCandidate.sizes || '100vw';
          }
          document.head.appendChild(lcpPreload);
        }
      }
    }
  }

  // PHASE 4: HIGH-PERFORMANCE INTERSECTION OBSERVER (DEFERRED) 📡
  function createAdvancedLazyLoader() {
    const scheduleWork = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
    
    scheduleWork(() => {
      if (!('IntersectionObserver' in window)) {
        // Fallback for old browsers - load visible images immediately
        const lazyImages = document.querySelectorAll('img[data-src], img[data-srcset]');
        const viewportHeight = window.innerHeight;
        lazyImages.forEach(img => {
          const rect = img.getBoundingClientRect();
          if (rect.top < viewportHeight * 2 && rect.bottom > -100) {
            loadImage(img);
          }
        });
        return;
      }
      
      // High-performance observer configuration
      const observerConfig = {
        rootMargin: '150px 0px 100px 0px',
        threshold: 0.1, // Single threshold for better performance
      };
      
      const imageObserver = new IntersectionObserver((entries) => {
        const batch = [];
        for (const entry of entries) {
          if (entry.isIntersecting) {
            batch.push(entry.target);
            imageObserver.unobserve(entry.target);
          }
        }
        
        if (batch.length > 0) {
          scheduleWork(() => {
            batch.forEach(img => loadImage(img));
          });
        }
      }, observerConfig);
      
      // Observe lazy images
      const lazyImages = document.querySelectorAll('img[data-src], img[data-srcset]');
      lazyImages.forEach(img => imageObserver.observe(img));
      
      // Store observer for cleanup
      window.lazyLoadObserver = imageObserver;
    });
  }
  
  // OPTIMIZED IMAGE LOADING FUNCTION 📸
  function loadImage(img) {
    if (img.classList.contains('lazy-loaded') || img.classList.contains('lazy-loading')) {
      return;
    }
    
    img.classList.add('lazy-loading');
    
    const tempImg = new Image();
    
    // Handle successful load
    tempImg.onload = function() {
      // Update actual image
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      
      // Smooth transition
      requestAnimationFrame(() => {
        img.classList.remove('lazy-loading');
        img.classList.add('lazy-loaded');
      });
    };
    
    // Handle errors gracefully
    tempImg.onerror = function() {
      img.classList.remove('lazy-loading');
      img.classList.add('lazy-error');
    };
    
    // Start loading
    if (img.dataset.srcset) tempImg.srcset = img.dataset.srcset;
    tempImg.src = img.dataset.src || img.src;
  }

  // PHASE 5: ADAPTIVE PERFORMANCE MONITORING 📊
  function initPerformanceMonitoring() {
    if (!('PerformanceObserver' in window)) return;
    
    try {
      const lcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lastEntry = entries[entries.length - 1];
        
        // Emergency optimization for poor LCP (>2.5s)
        if (lastEntry.value > 2500) {
          const lazyImages = document.querySelectorAll('img[loading="lazy"]:not(.priority-image)');
          const viewportHeight = window.innerHeight;
          let optimized = 0;
          
          for (const img of lazyImages) {
            if (optimized >= 5) break;
            const rect = img.getBoundingClientRect();
            if (rect.top < viewportHeight * 1.5 && rect.bottom > -100) {
              img.loading = 'eager';
              img.classList.add('priority-image');
              optimized++;
            }
          }
        }
      });
      
      lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
    } catch (e) {
      // Silently fail - monitoring is optional
    }
  }

  // PHASE 6: ORCHESTRATED INITIALIZATION 🎼
  function initializeOptimizedLoading() {
    // Schedule LCP optimization
    if (document.readyState !== 'loading') {
      optimizeLCPCandidate();
    } else {
      document.addEventListener('DOMContentLoaded', optimizeLCPCandidate, { once: true });
    }
    
    // Schedule lazy loading system
    createAdvancedLazyLoader();
    
    // Initialize performance monitoring
    initPerformanceMonitoring();
    
    // Handle dynamic content (AJAX, etc.) with debouncing
    let dynamicContentTimer;
    function handleDynamicContent() {
      clearTimeout(dynamicContentTimer);
      dynamicContentTimer = setTimeout(() => {
        optimizeLCPCandidate();
        createAdvancedLazyLoader();
      }, 150);
    }
    
    document.addEventListener('shopify:section:load', handleDynamicContent, { passive: true });
    document.addEventListener('product:loaded', handleDynamicContent, { passive: true });
  }

  // EXECUTE MAIN INITIALIZATION
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOptimizedLoading);
  } else {
    initializeOptimizedLoading();
  }

  // POLYFILL LOADER (ONLY IF NEEDED) 🔧
  if (!('IntersectionObserver' in window)) {
    const polyfillScript = document.createElement('script');
    polyfillScript.src = 'https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver';
    polyfillScript.async = true;
    document.head.appendChild(polyfillScript);
  }


// Toast notification for add to cart
let toastTimeout = null;

function showAddToCartToast() {
  // Remove any existing toast
  const existingToast = document.querySelector('.atc-toast');
  if (existingToast) {
    existingToast.remove();
  }
  
  // Clear any pending timeout
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
  }

  // Get toast settings
  const settings = window.themeVariables?.settings || {};
  const backgroundImage = settings.toastBackgroundImage || '';
  const hasBackgroundImage = backgroundImage && backgroundImage !== null && backgroundImage.trim() !== '';

  // Create toast element
  const toast = document.createElement('div');
  toast.className = 'atc-toast';
  
  // Apply background image styles if available (using recommended dimensions: 400x100px)
  if (hasBackgroundImage) {
    toast.style.backgroundImage = `url(${backgroundImage})`;
    toast.style.backgroundSize = 'cover';
    toast.style.backgroundPosition = 'center';
    toast.style.backgroundRepeat = 'no-repeat';
    toast.style.width = '400px';
    toast.style.height = '100px';
  }

  // Build toast content - only show text if no background image
  const messageContent = hasBackgroundImage 
    ? '' 
    : `
      <div class="atc-toast__message">
        <svg class="atc-toast__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6667 5.83333L7.50004 15L3.33337 10.8333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Added to cart!</span>
      </div>
    `;

  toast.innerHTML = `
    <div class="atc-toast__content">
      ${messageContent}
      <button class="atc-toast__close" aria-label="Close notification" type="button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="atc-toast__progress">
      <div class="atc-toast__progress-bar"></div>
    </div>
  `;

  // Add to body
  document.body.appendChild(toast);

  // Trigger animation
  requestAnimationFrame(() => {
    toast.classList.add('atc-toast--show');
  });

  // Close button handler
  const closeBtn = toast.querySelector('.atc-toast__close');
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    closeToast(toast);
  });

  // Click on toast to open cart
  toast.addEventListener('click', (e) => {
    // Don't open cart if clicking the close button
    if (e.target.closest('.atc-toast__close')) {
      return;
    }
    openCartDrawer();
    closeToast(toast);
  });

  // Auto-close after 3 seconds
  toastTimeout = setTimeout(() => {
    closeToast(toast);
    toastTimeout = null;
  }, 3000);
}

function closeToast(toast) {
  if (!toast) return;
  
  // Clear timeout if toast is manually closed
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
  }
  
  toast.classList.add('atc-toast--hide');
  setTimeout(() => {
    if (toast.parentNode) {
      toast.remove();
    }
  }, 300);
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.show === 'function') {
    cartDrawer.show();
  }
}

//round number

class RandomNumber extends HTMLElement {
  constructor() {
    super();
    // Include current URL path in storage key
    this.storageKey = `random-number-values-${window.location.pathname}`;

    // Initialize storage for this page if needed
    if (!sessionStorage.getItem(this.storageKey)) {
      sessionStorage.setItem(this.storageKey, JSON.stringify({}));
    }
  }

  generateUniqueId() {
    const allRandomNumbers = document.getElementsByTagName("random-number");
    for (let i = 0; i < allRandomNumbers.length; i++) {
      if (allRandomNumbers[i] === this) {
        return `random-number-${window.location.pathname}-${i}`;
      }
    }
    return `random-number-${window.location.pathname}-${Date.now()}`;
  }

  connectedCallback() {
    const min = parseInt(this.dataset.min) || 0;
    const max = parseInt(this.dataset.max) || 100;

    // Use element's ID or generate a stable one
    const elementId = this.getAttribute("id") || this.generateUniqueId();
    this.setAttribute("id", elementId);

    let storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));

    // Generate new value only if it doesn't exist for this page
    if (!storedValues[elementId]) {
      const newValue = Math.floor(Math.random() * (max - min + 1)) + min;
      storedValues[elementId] = newValue;
      sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
    }

    this.textContent = storedValues[elementId];
  }

  disconnectedCallback() {
    const elementId = this.getAttribute("id");
    const storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));
    if (storedValues && elementId) {
      delete storedValues[elementId];
      // Only remove from storage if no more values exist for this page
      if (Object.keys(storedValues).length === 0) {
        sessionStorage.removeItem(this.storageKey);
      } else {
        sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
      }
    }
  }
}
// Register the custom element
customElements.define("random-number", RandomNumber);

// color swatch pdp

class ProductSwatch extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleSwatchClick.bind(this));
  }

  // Handle swatch click event
  async handleSwatchClick(event) {
    event.preventDefault();

    // Get the product URL and handle from the data attributes
    const productUrl = this.dataset.productUrl;
    const productHandle = this.dataset.productHandle;

    if (!productUrl || !productHandle) return;

    // Show loading state
    this.setLoadingState(true);

    try {
      // Fetch the entire product page instead of just the section
      const response = await fetch(productUrl);
      const html = await response.text();

      // Parse the HTML content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find the product section to update
      const productSection = document.getElementById(this.getAttribute('data-section-id'));

      if (productSection) {
        // Get the corresponding section from the fetched HTML
        const newProductSection = doc.getElementById(this.getAttribute('data-section-id'));

        if (newProductSection) {
          // Replace the entire section content
          productSection.innerHTML = newProductSection.innerHTML;

          // Handle scripts more carefully to avoid redeclaration errors
          const scriptElements = productSection.querySelectorAll('script');
          scriptElements.forEach((oldScript) => {
            // Skip scripts that might cause redeclaration errors
            if (
              oldScript.textContent.includes('class') ||
              oldScript.textContent.includes('function') ||
              oldScript.textContent.includes('const ') ||
              oldScript.textContent.includes('let ') ||
              oldScript.textContent.includes('var ')
            ) {
              // For scripts that define classes/functions, we'll evaluate them in a safer way
              try {
                // Create a new function from the script content and execute it
                // This avoids redeclaration errors in the global scope
                const scriptContent = oldScript.textContent;
                const scriptFunc = new Function(scriptContent);
                scriptFunc();
              } catch (scriptError) {
                console.warn('Script execution error:', scriptError);
              }
            } else {
              // For other scripts (like inline event handlers), replace them normally
              const newScript = document.createElement('script');
              Array.from(oldScript.attributes).forEach((attr) => {
                newScript.setAttribute(attr.name, attr.value);
              });
              newScript.appendChild(document.createTextNode(oldScript.innerHTML));
              oldScript.parentNode.replaceChild(newScript, oldScript);
            }
          });

          // Dispatch events to notify other components
          document.dispatchEvent(
            new CustomEvent('shopify:section:load', {
              detail: { section: productSection },
            })
          );

          document.dispatchEvent(
            new CustomEvent('product:loaded', {
              bubbles: true,
              detail: { productElement: productSection },
            })
          );
        }
      }

      // Update the URL in the browser without reloading the page
      history.replaceState(null, '', productUrl);
    } catch (error) {
      console.error('Error fetching product:', error);
    } finally {
      // Hide loading state
      this.setLoadingState(false);
      this.scrollToTop();
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 150,
      behavior: 'smooth',
    });
  }

  // Set loading state for the carousel
  setLoadingState(isLoading) {
    const carousel = this.closest('custom-carousel');
    if (carousel) {
      carousel.classList.toggle('loading', isLoading);
    }
  }
}

// Define the custom element
customElements.define('product-swatch', ProductSwatch);
  

// Product Card Swatch Handler - Updates product card DOM dynamically
class ProductCardSwatchHandler {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation to handle clicks on product card swatches
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-product-card-swatch]');
      if (!swatch) return;

      event.preventDefault();
      this.updateProductCard(swatch);
    });
  }

  updateProductCard(swatch) {
    const productCard = swatch.closest('product-card');
    if (!productCard) return;

    // Get all product data from data attributes
    const productData = {
      id: swatch.dataset.productId,
      handle: swatch.dataset.productHandle,
      url: swatch.dataset.productUrl,
      title: swatch.dataset.productTitle,
      type: swatch.dataset.productType,
      price: parseInt(swatch.dataset.productPrice),
      compareAtPrice: parseInt(swatch.dataset.productCompareAtPrice) || 0,
      priceFormatted: swatch.dataset.productPriceFormatted,
      compareAtPriceFormatted: swatch.dataset.productCompareAtPriceFormatted,
      imageUrl: swatch.dataset.productImageUrl,
      secondaryImageUrl: swatch.dataset.productSecondaryImageUrl || '',
      variantId: swatch.dataset.productVariantId,
      rating: swatch.dataset.productRating || '',
      reviewsCount: parseInt(swatch.dataset.productReviewsCount) || 0,
      sizes: swatch.dataset.productSizes || '',
      hasCombo: swatch.dataset.productHasCombo === 'true',
      available: swatch.dataset.productAvailable === 'true',
      inventoryQuantity: parseInt(swatch.dataset.productInventoryQuantity) || 0,
      hasLowStockTag: swatch.dataset.productHasLowStockTag === 'true'
    };

    // Show loading state with minimum display time
    const startTime = Date.now();
    const minLoaderTime = 1000; // 1 second minimum
    
    productCard.classList.add('updating');

    try {
      // Update product card handle attribute
      productCard.setAttribute('handle', productData.handle);

      // Update badges (sold-out badge based on availability)
      const badgeList = productCard.querySelector('.badge-list');
      if (badgeList) {
        const soldOutBadge = badgeList.querySelector('.badge--sold-out, sold-out-badge');
        if (soldOutBadge) {
          if (!productData.available) {
            soldOutBadge.removeAttribute('hidden');
            soldOutBadge.style.display = '';
          } else {
            soldOutBadge.setAttribute('hidden', '');
            soldOutBadge.style.display = 'none';
          }
        }
      }

      // Update product title
      const titleLink = productCard.querySelector('.product-title');
      if (titleLink) {
        titleLink.textContent = productData.title;
        titleLink.href = productData.url;
      }

      // Update product type
      const typeContainer = productCard.querySelector('.product-type-card-container');
      if (typeContainer) {
        const typeCard = typeContainer.querySelector('.product-type-card:not(.product-type-card-combo)');
        if (typeCard) {
          typeCard.textContent = productData.type;
        }

        // Update combo tag
        const comboCard = typeContainer.querySelector('.product-type-card-combo');
        if (productData.hasCombo) {
          if (!comboCard) {
            const newComboCard = document.createElement('div');
            newComboCard.className = 'product-type-card product-type-card-combo';
            newComboCard.textContent = 'Make Your Combo';
            typeContainer.appendChild(newComboCard);
          }
        } else if (comboCard) {
          comboCard.remove();
        }
      }

      // Update product images
      const primaryImage = productCard.querySelector('.product-card__image--primary');
      const secondaryImage = productCard.querySelector('.product-card__image--secondary');
      const mediaLink = productCard.querySelector('.product-card__media');

      if (primaryImage && productData.imageUrl) {
        primaryImage.src = productData.imageUrl;
        primaryImage.srcset = '';
        // Update srcset for responsive images
        const widths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];
        const srcset = widths.map(w => {
          const url = productData.imageUrl.replace(/width=\d+/, `width=${w}`);
          return `${url} ${w}w`;
        }).join(', ');
        primaryImage.srcset = srcset;
        primaryImage.loading = 'lazy';
      }

      if (secondaryImage && productData.secondaryImageUrl) {
        secondaryImage.src = productData.secondaryImageUrl;
        secondaryImage.srcset = '';
        const widths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];
        const srcset = widths.map(w => {
          const url = productData.secondaryImageUrl.replace(/width=\d+/, `width=${w}`);
          return `${url} ${w}w`;
        }).join(', ');
        secondaryImage.srcset = srcset;
        secondaryImage.style.display = '';
      } else if (secondaryImage && !productData.secondaryImageUrl) {
        secondaryImage.style.display = 'none';
      }

      if (mediaLink) {
        mediaLink.href = productData.url;
      }

      // Update price
      const priceContainer = productCard.querySelector('.product-card__price-container');
      if (priceContainer) {
        const priceList = priceContainer.querySelector('price-list');
        if (priceList) {
          // Update sale price
          const salePrice = priceList.querySelector('sale-price');
          if (salePrice) {
            salePrice.textContent = productData.priceFormatted;
          }

          // Update compare at price
          const comparePrice = priceList.querySelector('compare-at-price');
          if (productData.compareAtPrice > productData.price) {
            if (comparePrice) {
              comparePrice.textContent = productData.compareAtPriceFormatted;
              comparePrice.style.display = '';
            } else {
              // Create compare at price element if it doesn't exist
              const newComparePrice = document.createElement('compare-at-price');
              newComparePrice.className = 'text-subdued line-through';
              newComparePrice.textContent = productData.compareAtPriceFormatted;
              priceList.insertBefore(newComparePrice, salePrice);
            }
          } else if (comparePrice) {
            comparePrice.style.display = 'none';
          }
        }
        
        // Update inventory display
        const inventoryElement = priceContainer.querySelector('.product-card__inventory');
        if (productData.hasLowStockTag && productData.available && productData.inventoryQuantity > 0 && productData.inventoryQuantity <= 10) {
          if (inventoryElement) {
            inventoryElement.textContent = `Only ${productData.inventoryQuantity} left`;
            inventoryElement.style.display = '';
          } else {
            // Create inventory element if it doesn't exist
            const newInventoryElement = document.createElement('p');
            newInventoryElement.className = 'product-card__inventory';
            newInventoryElement.textContent = `Only ${productData.inventoryQuantity} left`;
            priceContainer.appendChild(newInventoryElement);
          }
        } else if (inventoryElement) {
          inventoryElement.style.display = 'none';
        }
      }

      // Update size display
      const sizeDisplay = productCard.querySelector('.product-card__info p[style*="font-size: 10px"]');
      if (sizeDisplay && productData.sizes) {
        const sizeArray = productData.sizes.split('|');
        sizeDisplay.textContent = sizeArray.join(' | ');
      } else if (sizeDisplay && !productData.sizes) {
        sizeDisplay.textContent = '';
      }

      // Update rating
      const ratingContainer = productCard.querySelector('.rating-product-card');
      if (productData.reviewsCount > 0 && productData.rating) {
        if (ratingContainer) {
          const roundRating = ratingContainer.querySelector('round-rating');
          const reviewsCount = ratingContainer.querySelector('div');
          if (roundRating) roundRating.textContent = productData.rating;
          if (reviewsCount) reviewsCount.textContent = `(${productData.reviewsCount})`;
          ratingContainer.style.display = '';
        }
      } else if (ratingContainer) {
        ratingContainer.style.display = 'none';
      }

      // Update wishlist button - recreate it completely and manually bind Swym functionality
      const wishlistContainer = productCard.querySelector('.wishlist-icon-product-card');
      const oldWishlistButton = productCard.querySelector('.swym-button');
      if (wishlistContainer && oldWishlistButton) {
        // Remove old button completely
        oldWishlistButton.remove();
        
        // Create a completely new button element
        const newWishlistButton = document.createElement('button');
        newWishlistButton.setAttribute('aria-label', `Add ${productData.title} to Wishlist`);
        newWishlistButton.setAttribute('data-with-epi', 'true');
        newWishlistButton.setAttribute('data-swaction', 'addToWishlist');
        newWishlistButton.setAttribute('data-product-id', productData.id);
        newWishlistButton.setAttribute('data-variant-id', productData.variantId);
        
        // Ensure we use the full URL (productData.url should already be full URL from Liquid)
        // If it's relative, construct the full URL
        let productUrl = productData.url;
        if (productUrl && !productUrl.startsWith('http')) {
          // If it's a relative URL, make it absolute
          productUrl = `${window.location.origin}${productUrl.startsWith('/') ? '' : '/'}${productUrl}`;
        }
        newWishlistButton.setAttribute('data-product-url', productUrl);
        
        newWishlistButton.className = `swym-button swym-add-to-wishlist-view-product product_${productData.id}`;
        
        // Don't manually bind handlers - let Swym handle it
        // The button will be initialized via the swym:collections-loaded event
        
        // Append the new button
        wishlistContainer.appendChild(newWishlistButton);
        
        // Also try to initialize via Swym's normal method (but don't rely on it)
        // Swym will be reinitialized via the swym:collections-loaded event dispatched in the finally block
      }

      // Update quick buy modal
      const quickBuyModal = productCard.querySelector('quick-buy-modal');
      if (quickBuyModal) {
        quickBuyModal.setAttribute('handle', `${productData.handle}?variant=${productData.variantId}`);
        const quickBuyId = quickBuyModal.id;
        const quickBuyButton = productCard.querySelector(`[aria-controls="${quickBuyId}"]`);
        if (quickBuyButton && !productData.available) {
          quickBuyButton.style.display = 'none';
        } else if (quickBuyButton) {
          quickBuyButton.style.display = '';
        }
      }

      // Update active swatch state
      const allSwatches = productCard.querySelectorAll('[data-product-card-swatch]');
      allSwatches.forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      // Dispatch custom event for other components that might need to react
      productCard.dispatchEvent(new CustomEvent('product-card:updated', {
        bubbles: true,
        detail: { productData }
      }));

    } catch (error) {
      console.error('Error updating product card:', error);
    } finally {
      // Ensure loader shows for at least 1 second for better UX
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minLoaderTime - elapsedTime);
      
      setTimeout(() => {
        productCard.classList.remove('updating');
        
        // Dispatch Swym event to reinitialize wishlist buttons after product card update
        // This ensures Swym properly updates the wishlist button state (filled/unfilled icon)
        // Use a longer delay to ensure button recreation is complete and DOM is stable
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
        }, 500);
      }, remainingTime);
    }
  }
}

// Initialize the handler
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardSwatchHandler();
    updateSwatchSizes();
  });
} else {
  new ProductCardSwatchHandler();
  updateSwatchSizes();
}

// Function to dynamically update swatch sizes based on card width
function updateSwatchSizes() {
  const updateSwatches = () => {
    const swatchContainers = document.querySelectorAll('.product-card__similar-swatches');
    
    swatchContainers.forEach(container => {
      const hStack = container.querySelector('.h-stack');
      if (!hStack) return;
      
      const containerWidth = container.offsetWidth;
      // gap-1 = 0.25rem = 4px (assuming 16px base)
      const gapSizePx = 4;
      const numSwatches = hStack.querySelectorAll('.product-card__similar-swatch').length || 6;
      const numGaps = Math.max(0, numSwatches - 1);
      const totalGapSpace = gapSizePx * numGaps;
      
      // Calculate swatch width: (container width - total gap space) / number of swatches
      const swatchWidth = (containerWidth - totalGapSpace) / numSwatches;
      
      // Set CSS custom property for dynamic sizing
      container.style.setProperty('--swatch-calculated-size', `${swatchWidth}px`);
    });
  };

  // Update on load
  updateSwatches();

  // Update on resize with debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateSwatches, 100);
  });

  // Update when new swatches are added (using MutationObserver)
  const observer = new MutationObserver(() => {
    updateSwatches();
  });

  document.querySelectorAll('.product-card__similar-swatches').forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });
}

class ShowMore extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();

    // Find the details accordion element
    const detailsAccordion = document.getElementById('details-accordion');

    if (detailsAccordion) {
      // Add the open attribute to expand the accordion
      detailsAccordion.setAttribute('open', '');

      // Scroll to the element with smooth behavior
      detailsAccordion.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }
}

// Register the custom element
if (!customElements.get('show-more')) {
  customElements.define('show-more', ShowMore);
}

// cross sell product card
class CrossSellProductCard extends HTMLElement {
  constructor() {
    super();
    this.quickBuyId = this.getAttribute('quick-buy-id');
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    const checkbox = this.querySelector('.cross-sell-product-card__checkbox');
    const addButton = this.querySelector('.cross-sell-product-card__add-button');
    const viewButton = this.querySelector('.cross-sell-product-card__view-button');
    const mediaButton = this.querySelector('.cross-sell-product-card__media--quick-view');

    // Handle checkbox change for single variant products
    if (checkbox) {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          const variantId = e.target.getAttribute('data-variant-id');
          this.addToCart(variantId);
        }
      });
    }

    // Handle media button click for multi-variant products (quick view)
    if (mediaButton) {
      mediaButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openQuickBuy();
      });
    }

    // Handle add button click for multi-variant products
    if (addButton) {
      addButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.openQuickBuy();
      });
    }

    // Handle view button click
    if (viewButton) {
      viewButton.addEventListener('click', () => {
        this.openQuickBuy();
      });
    }
  }

  openQuickBuy() {
    const quickBuyModal = this.querySelector('.quick-buy-modal') || document.getElementById(this.quickBuyId);
    if (quickBuyModal && quickBuyModal.show) {
      quickBuyModal.show();
    }
  }

  async addToCart(variantId) {
    // Disable checkbox during request
    const checkbox = this.querySelector('.cross-sell-product-card__checkbox');
    if (checkbox) {
      checkbox.disabled = true;
    }

    try {
      // Prepare sections for cart update (following existing pattern)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      
      document.body.classList.add('loading-spinner');
      if (typeof window.showCustomLoadingOverlay === 'function') {
        window.showCustomLoadingOverlay();
      }

      // Add to cart using the same format as existing system
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }],
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const responseJson = await response.json();

      if (response.ok) {
        // Get updated cart content
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        // Dispatch variant:add event (following existing pattern)
        document.documentElement.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent,
            },
          })
        );

        // Dispatch cart:change event (following existing pattern)
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );

        // If inside pair-with dropdown, notify to close it
        const pairWithDropdown = this.closest('product-pair-with-dropdown');
        if (pairWithDropdown) {
          pairWithDropdown.dispatchEvent(new CustomEvent('pair-with:product-added', { bubbles: true }));
        }

        // Don't remove the card on PDP pair-with section; keep it visible for re-add
        const isPdpPairWith = this.closest('product-pair-with-dropdown') || this.closest('product-list-carousel-container');
        if (!isPdpPairWith) {
          this.style.animation = 'fadeOut 0.3s ease-out forwards';
          setTimeout(() => {
            this.remove();
          }, 300);
        } else {
          // Re-enable checkbox so user can add again if they remove from cart
          if (checkbox) {
            checkbox.disabled = false;
            checkbox.checked = false;
          }
        }

      } else {
        throw new Error(responseJson.description || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      // Re-enable checkbox and reset state
      if (checkbox) {
        checkbox.disabled = false;
        checkbox.checked = false;
      }
      
      // Show error feedback
      alert(error.message || 'Failed to add product to cart. Please try again.');
    }
    finally {
      document.body.classList.remove('loading-spinner');
      if (typeof window.hideCustomLoadingOverlay === 'function') {
        window.hideCustomLoadingOverlay();
      }
    }
  }
}

// Define the custom element
customElements.define('cross-sell-product-card', CrossSellProductCard);

class BottomCart extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateHandler = this.handleCartUpdate.bind(this);
    this.bundleSectionsHandler = this.handleBundleSections.bind(this);
    this.refreshCartHandler = this.handleRefreshCart.bind(this);
  }

  connectedCallback() {
    // Add event listeners
    document.addEventListener("cart:change", this.cartUpdateHandler);
    document.addEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.addEventListener("cart:refresh", this.refreshCartHandler);
  }

  disconnectedCallback() {
    // Remove event listeners
    document.removeEventListener("cart:change", this.cartUpdateHandler);
    document.removeEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.removeEventListener("cart:refresh", this.refreshCartHandler);
  }

  handleBundleSections(event) {
    // Add this section's ID to the sections that should be updated
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );
    event.detail.sections.push(sectionId);
  }

  handleCartUpdate(event) {
    const cartData = event.detail.cart;
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Get the updated HTML for this section
    const sectionHtml = cartData.sections[sectionId];

    if (sectionHtml) {
      // Parse and update the section content
      const domElement = new DOMParser().parseFromString(
        sectionHtml,
        "text/html"
      );
      const newContent = domElement.querySelector("bottom-cart").innerHTML;
      this.innerHTML = newContent;
    }
  }

  async handleRefreshCart() {
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Fetch the latest cart section HTML
    const response = await fetch(
      `${window.Shopify.routes.root}?section_id=${sectionId}`
    );
    const html = await response.text();

    // Parse and update the section content
    const domElement = new DOMParser().parseFromString(html, "text/html");
    const newContent = domElement.querySelector("bottom-cart").innerHTML;
    this.innerHTML = newContent;
  }
}

// Register the custom element if it hasn't been registered yet
if (!customElements.get("bottom-cart")) {
  customElements.define("bottom-cart", BottomCart);
}

// =====================
// Page View Grid Handler
// =====================
// 
(() => {
  // Use a document-level delegate so the handler survives #main swaps
  if (window.__pageViewGridInit) return;
  window.__pageViewGridInit = true;

  function startLoading() {
    document.body.classList.add('loading-spinner');
    if (typeof window.showCustomLoadingOverlay === 'function') {
      window.showCustomLoadingOverlay();
    }
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
  }

  function stopLoading() {
    document.body.classList.remove('loading-spinner');
    if (typeof window.hideCustomLoadingOverlay === 'function') {
      window.hideCustomLoadingOverlay();
    }
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
  }

  let isNavigating = false;

  async function navigate(fetchUrl, pageTitle, shouldPushState) {
    const main = document.getElementById('main');
    if (!main) return;

    if (isNavigating) return;
    isNavigating = true;

    startLoading();

    try {
      const response = await fetch(fetchUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('fetch failed');

      const html = await response.text();
      const tempDoc = new DOMParser().parseFromString(html, 'text/html');
      const nextMain = tempDoc.getElementById('main');

      if (!nextMain) throw new Error('no #main in response');

      // Don't inject footer - it's already on page (moved by fastload) and would duplicate
      const footerInNext = nextMain.querySelector('footer');
      if (footerInNext) footerInNext.remove();

      main.replaceWith(nextMain);
      document.title = tempDoc.title || document.title;

      setActiveBlock(fetchUrl);

      if (shouldPushState) {
        // Keep current base URL, only append page-view param
        const displayUrl = new URL(window.location.href);
        displayUrl.searchParams.set('page-view', pageTitle);
        history.pushState({ pageView: true, fetchUrl, pageTitle }, '', displayUrl.toString());
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.warn('[page-view-grid] navigate error:', err);
    } finally {
      stopLoading();
      isNavigating = false;
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }
  }

  function setActiveBlock(fetchUrl) {
    document.querySelectorAll('[data-page-view-section] [data-page-fetch-url]').forEach((el) => {
      el.classList.toggle('is-active', el.getAttribute('data-page-fetch-url') === fetchUrl);
    });
  }

  function normalizeTitle(value) {
    return (value || '').trim().toLowerCase();
  }

  function initFromPageViewParam() {
    const params = new URLSearchParams(window.location.search);
    const pageView = params.get('page-view');
    const blocks = document.querySelectorAll('[data-page-view-section] [data-page-fetch-url][data-page-title]');
    if (!blocks.length) return;

    if (!pageView) return;

    const normalizedParam = normalizeTitle(pageView);
    const matchingBlock = Array.from(blocks).find((el) => {
      return normalizeTitle(el.getAttribute('data-page-title')) === normalizedParam;
    });

    if (!matchingBlock) return;

    const fetchUrl = matchingBlock.getAttribute('data-page-fetch-url');
    const pageTitle = matchingBlock.getAttribute('data-page-title');
    if (!fetchUrl) return;

    history.replaceState({ pageView: true, fetchUrl, pageTitle }, '', window.location.href);
    setActiveBlock(fetchUrl);
    navigate(fetchUrl, pageTitle, false);
  }

  document.addEventListener('click', function(event) {
    // Only handle real user clicks, not synthetic/programmatic events
    if (!event.isTrusted) return;

    const trigger = event.target.closest('[data-page-fetch-url]');
    if (!trigger) return;

    // Only handle clicks inside a page-view-grid section
    if (!trigger.closest('[data-page-view-section]')) return;

    event.preventDefault();

    const fetchUrl = trigger.getAttribute('data-page-fetch-url');
    const pageTitle = trigger.getAttribute('data-page-title');
    navigate(fetchUrl, pageTitle, true);
  });

  window.addEventListener('popstate', function(event) {
    if (event.state && event.state.pageView && event.state.fetchUrl) {
      setActiveBlock(event.state.fetchUrl);
      navigate(event.state.fetchUrl, event.state.pageTitle, false);
    }
  });

  initFromPageViewParam();
})();